import Axios from 'axios';
import queryString from 'query-string';

// Axios: This has to be done as early as possible
// ⚠ This returns an Axios instance without interceptors
const getAxiosInstance = () =>
  Axios.create({
    baseURL: process.env.REACT_APP_PUBLIC_URL_BASE,
    paramsSerializer: {
      serialize: params => queryString.stringify(params)
    }
  });

export const restClient = getAxiosInstance();
